import React, { useState, useEffect, useRef } from 'react';
import { Chip, Typography, Paper, Popper } from '@material-ui/core';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { loadTags } from '../../services/api';

const TagEditor = ({ book, bookStore, userStore }) => {
  const [editing, setEditing] = useState(false);
  const [tags, setTags] = useState([]);
  const anchorRef = useRef(null);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await loadTags(userStore.token);
        // Filter out tags that are already assigned to the book
        const assignedTagIds = new Set((book.book?.admin_tags || []).map(tag => tag.id));
        const availableTags = response.data.data.filter(tag => !assignedTagIds.has(tag.id));
        setTags(availableTags);
      } catch (error) {
        console.error('Error loading tags:', error);
      } finally {
      }
    };

    if (editing) {
      fetchTags();
    }
  }, [editing, userStore.token, book.book?.admin_tags]);

  const handleAddTag = async (tag) => {
    try {
      await bookStore.addTag(book, tag);
      setEditing(false);
    } catch (error) {
      console.error('Error adding tag:', error);
    }
  };

  if (!editing) {
    return (
      <AddCircleIcon
        onClick={() => setEditing(true)}
        sx={{ cursor: 'pointer', color: 'primary.main' }}
      />
    );
  }

  return (
    <div>

      <AddCircleIcon
        ref={anchorRef}
        onClick={() => setEditing(false)}
        sx={{ cursor: 'pointer', color: 'primary.main' }}
      />

      <Popper placement="auto" open={editing} anchorEl={anchorRef.current} style={{ zIndex: 2 }}>
        {tags.length === 0 && (
          <Typography variant="body2">Nenhuma tag disponível</Typography>
        )}
        <Paper style={{ backgroundColor: '#eee' }} sx={{ padding: 2}}>
          {tags.map((tag) => <Chip label={tag.name} style={{backgroundColor: tag.color, color: 'white'}} onClick={() => handleAddTag(tag)} />)}
        </Paper>
      </Popper>


    </div>
  );
};

export default TagEditor;
